var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("app-country-code-autocomplete", {
        attrs: { value: _vm.singleValue, label: _vm.label, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.setSingleValue($event)
          },
        },
      })
    : _vm.multi
    ? _c(
        "w-col",
        { attrs: { xs: "12", "no-margin": "" } },
        [
          _c("app-country-code-autocomplete", {
            attrs: { value: null, fancy: "", label: _vm.label },
            on: {
              input: function ($event) {
                return _vm.addCountry($event)
              },
            },
          }),
          _c(
            "div",
            _vm._l(_vm.value, function (country, i) {
              return _c(
                "w-chip",
                {
                  key: i,
                  staticClass: "chip",
                  attrs: { closable: "" },
                  on: {
                    close: function ($event) {
                      return _vm.removeCountry(i)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getCountryName(country)))]
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }